import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-nav_wechat_history",
  "use": "icon-nav_wechat_history-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-nav_wechat_history\"><path d=\"M512 73.1136A438.8864 438.8864 0 1 1 73.1136 512 438.8864 438.8864 0 0 1 512 73.1136M512 0a512 512 0 1 0 512 512 512 512 0 0 0-512-512z m-36.5568 219.4432a36.5568 36.5568 0 0 0-36.5568 36.5568v292.5568a36.5568 36.5568 0 0 0 73.1136 0V256a36.5568 36.5568 0 0 0-36.5568-36.5568zM768 512H475.4432a36.5568 36.5568 0 1 0 0 73.1136H768A36.5568 36.5568 0 0 0 768 512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol